import { Injectable } from '@angular/core';

import { toCent } from '@frontend/sports/common/core/utils/math';
import { TrackData, TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';

import { AutoCashoutTracking, CashoutSettingsType } from '../../my-bets-base/models/early-payout';

@Injectable()
export class AutoCashoutTrackingService {
    myBetsTrackSufix = '';
    constructor(private trackingService: TrackingService) {}

    trackSetClick(
        setType: CashoutSettingsType,
        betNumber: string,
        value: number,
        betType: string,
        isFreeBet: boolean,
        containsLiveBets: boolean,
    ): void {
        const labelEvent = 'save click';
        const trackingName = 'CashOut_Notification_SetRule_Save_Click';

        this.track(setType, betNumber, betType, isFreeBet, labelEvent, containsLiveBets, trackingName, value);
    }

    trackSetSuccess(
        setType: CashoutSettingsType,
        betNumber: string,
        value: number,
        betType: string,
        isFreeBet: boolean,
        containsLiveBets: boolean,
    ): void {
        const labelEvent = 'success';
        const trackingName = 'CashOut_Notification_Set_Rule_Save_Success';

        this.track(setType, betNumber, betType, isFreeBet, labelEvent, containsLiveBets, trackingName, value);
    }

    trackRemoveClick(
        setType: CashoutSettingsType,
        betNumber: string,
        betType: string,
        isFreeBet: boolean,
        containsLiveBets: boolean,
        value?: number,
    ): void {
        const labelEvent = 'remove rule click';
        const trackingName = 'CashOut_Notification_RemoveRule_Click';

        this.track(setType, betNumber, betType, isFreeBet, labelEvent, containsLiveBets, trackingName, value);
    }

    trackRemoveSuccess(
        setType: CashoutSettingsType,
        betNumber: string,
        betType: string,
        isFreeBet: boolean,
        containsLiveBets: boolean,
        value?: number,
    ): void {
        const labelEvent = 'rule removed';
        const trackingName = 'CashOut_Notification_RemoveRule_Removed';

        this.track(setType, betNumber, betType, isFreeBet, labelEvent, containsLiveBets, trackingName, value);
    }

    private track(
        setType: CashoutSettingsType,
        betNumber: string,
        betType: string,
        isFreeBet: boolean,
        labelEvent: string,
        containsLiveBets: boolean,
        trackingName: string,
        value?: number,
    ): void {
        if (setType === CashoutSettingsType.Auto) {
            this.trackAutoCashout(<AutoCashoutTracking>{
                betNumber,
                eventName: this.getEventName(setType),
                value,
                betType,
                isFreeBet,
                labelEvent,
                containsLiveBets,
            });
        } else {
            this.trackNotification(<AutoCashoutTracking>{
                betNumber,
                eventName: this.getEventName(setType),
                trackingName,
                value,
            });
        }
    }

    private trackAutoCashout(request: AutoCashoutTracking): void {
        this.trackingService.track(
            request.eventName,
            this.getAutoCashoutBaseTracking(
                request.labelEvent,
                request.betNumber,
                request.betType,
                request.isFreeBet,
                request.containsLiveBets,
                request.value,
            ),
        );
    }

    private trackNotification(request: AutoCashoutTracking): void {
        this.trackingService.track(request.eventName, {
            [trackingConstants.COMPONENT_AUTO_EARLYPAYOUT]: `${request.trackingName}_${this.myBetsTrackSufix}`,
            earlyPayoutSlipID: request.betNumber,
            autoCashoutAmount: request.value,
        });
    }

    private getEventName(setType: CashoutSettingsType): string {
        return setType === CashoutSettingsType.Auto ? 'event.AutoearlyPayoutSet' : 'event.EarlyPayoutNotificationSet';
    }

    private getAutoCashoutBaseTracking(
        labelEvent: string,
        betslipId: string,
        betType: string,
        isFreeBet: boolean,
        containsLiveBets: boolean,
        earlyPayoutAmount?: number,
    ): Partial<TrackData> {
        return {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: 'early payout auto set up',
            [trackingConstants.COMPONENT_LABEL_EVENT]: labelEvent,
            [trackingConstants.COMPONENT_ACTION_EVENT]: 'attempt',
            [trackingConstants.COMPONENT_POSITION_EVENT]: betType,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: (containsLiveBets ? 'live/' : 'main/') + this.myBetsTrackSufix,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: isFreeBet ? 'freebet' : 'real money bet',
            earlyPayoutSlipID: betslipId,
            autoCashoutAmount: earlyPayoutAmount === undefined ? undefined : toCent(earlyPayoutAmount),
        };
    }
}
